import React, { Component } from 'react';
// redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
// components
import { Route } from 'react-router-dom';
import MainLayout from '../MainLayout';
// styles
import styles from './AuthorizedRoute.mod.css';

class AuthorizedRoute extends Component {
  constructor(props) {
    super(props);
    this.checkAuth(props);
  }

  componentWillReceiveProps(nextProps) {
    this.checkAuth(nextProps);
  }

  checkAuth = ({ authenticated, location, history }) => {
    if (authenticated === false) {
      history.replace(`/login?redirect=${location.pathname}`);
    }
  };

  render() {
    const {
      component: Component,
      background,
      blobs = false,
      authenticated,
      dashboardMenu,
      backLink,
      clientOnly,
      supportOnly,
      user,
      locked,
      history,
      ...routeProps
    } = this.props;

    const hasNoAccess =
      locked ||
      (authenticated &&
        ((clientOnly && user.role !== 'client') ||
          (supportOnly && user.role !== 'support')));

    if (hasNoAccess) {
      if (user.progress.module !== 0) {
        history.replace('/404');
        return null;
      }
    }

    return authenticated ? (
      <Route
        {...routeProps}
        render={matchProps => (
          <MainLayout
            background={background}
            blobs={blobs}
            backLink={backLink}
            dashboardMenu={dashboardMenu}
          >
            <Component {...matchProps} />
          </MainLayout>
        )}
      />
    ) : (
      <div className={styles.loading}>LOADING...</div>
    );
  }
}

const enhancer = compose(
  connect(state => ({
    user: state.auth.user,
    authenticated: state.auth.authenticated,
  })),
  withRouter
);

export default enhancer(AuthorizedRoute);



// WEBPACK FOOTER //
// ./src/layouts/routes/AuthorizedRoute.jsx